import { render, staticRenderFns } from "./UnAuthorized.vue?vue&type=template&id=5e11ed0a&"
import script from "./UnAuthorized.vue?vue&type=script&lang=js&"
export * from "./UnAuthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports